import DualTabsHandler from "./components/dualCategories/DualTabsHandler";
import DualTabsAjaxHandler from "./components/dualCategories/DualTabsAjaxHandler";

document.addEventListener("DOMContentLoaded", async () => {
    await handleDualTabs();
    await handleDualAjaxTabs();
});

const handleDualTabs = async (): Promise<void> => {
    const wrapper = <HTMLElement>document.querySelector(".webinars-categories-container");

    if (!wrapper) return;

    new DualTabsHandler(wrapper);
};

const handleDualAjaxTabs = async (): Promise<void> => {
    const section = <HTMLElement>document.querySelector(".webinars");
    const cardsWrapper = section.querySelector(".webinars-content-container--cards") as HTMLElement;

    if (!section || !cardsWrapper) return;

    new DualTabsAjaxHandler(section, "webinar-category", cardsWrapper);
};
